/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulesetname2Inputs */

const en_entity_rulesetname2 = /** @type {(inputs: Entity_Rulesetname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Set Name`)
};

const de_entity_rulesetname2 = /** @type {(inputs: Entity_Rulesetname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Rule Set Name" |
*
* @param {Entity_Rulesetname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulesetname2 = /** @type {((inputs?: Entity_Rulesetname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulesetname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulesetname2(inputs)
	return de_entity_rulesetname2(inputs)
});
export { entity_rulesetname2 as "entity_ruleSetName" }